"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var continueButtonsStyles_1 = require("./continueButtonsStyles");
var react_1 = require("react");
var DefaultButton_1 = require("../../../../common/components/presentation/Buttons/DefaultButton");
var ArrowBackIos_1 = require("@material-ui/icons/ArrowBackIos");
var core_1 = require("@material-ui/core");
var ContinueButton = function (_a) {
    var onClick = _a.onClick, testId = _a.testId, _b = _a.withIcon, withIcon = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, children = _a.children, className = _a.className;
    var _d;
    var styles = continueButtonsStyles_1.default();
    var checkout4 = core_1.useTheme().checkoutLite.checkout4;
    return (<DefaultButton_1.default onClick={onClick} className={[styles.continueButton, className]} variant="contained" dataTest={testId} disabled={disabled} contained={styles.contained} containedPrimary={styles.containedPrimary} disableTouchRipple={(_d = checkout4) === null || _d === void 0 ? void 0 : _d.disableTouchRipple}>
      <>
        {!!withIcon && <ArrowBackIos_1.default className={styles.icon}/>}
        {children}
      </>
    </DefaultButton_1.default>);
};
exports.default = ContinueButton;
